const React = require("react");
const {openPopupWindow} = require("../../../../../emitters/popup");
const Popup = require("../../../Popup/C");
const FormUpdateCheck = require("../components/FormUpdateCheck");

module.exports = ({payload, onSubmit, onResult}) => openPopupWindow((setPopupState, popup, onMount) => {
  const {close} = popup;

  onMount(() => {
    return () => onResult();
  })

  return () => {
    return (
      <Popup
        caption={(
          <div className="layoutRow fhaS fvaC w">
            <div>Confirm update</div>
          </div>
        )}
      >
        <div className="mt20">Do you want to update fee settings?</div>
        <FormUpdateCheck
          onSubmit={({confirmBearer}) => onSubmit({payload, confirmBearer})}
          close={close}
        />
      </Popup>
    );
  };
});
